import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { SocialMediaFileDirective } from 'src/app/core/directives/social-media-file.directive';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { FileControllerModule } from 'src/app/shared/components/file-controller/file-controller.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-show-medias',
    templateUrl: './show-medias.component.html',
    imports: [
        FileControllerModule,
        TranslateModule,
        MatTooltipModule,
        SocialMediaFileDirective,
        ModalTitleComponent,
        BaseFormModule,
    ]
})
export class ShowMediaComponent
  extends BaseFormPageComponent
  implements OnInit
{
  fileUrl: string;
  mediaId: number;
  fileTypes;

  constructor(
    private dialogRef: MatDialogRef<ShowMediaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    if (data) {
      this.mediaId = data?.mediaId;
      this.fileUrl = data?.fileUrl;
      this.fileTypes = data?.fileTypes;
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  initForm() {}

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
